import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, concatMap, map, of, throwError } from 'rxjs';
import { AddBillingitemsWizardDataService } from 'src/app/services/wizards/add-billingitems-wizard.service';
import { AddServicesToBillingaccountsWizardActions } from '.';
import { State } from './state';

@Injectable()
export class AddServicesToBillingaccountsWizardEffects {
  newAddServicesToBillingaccounts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddServicesToBillingaccountsWizardActions.createNewAddServicesToBillingaccounts),
      concatMap(({ request }) =>
        this.addBillingitemsWizardService.addBillingitemsToBillingaccounts(request).pipe(
          map((response) => {
            if (response) {
              return AddServicesToBillingaccountsWizardActions.createNewAddServicesToBillingaccountsSuccess({
                response: response.data,
              });
            } else {
              throwError('No data received');
            }
          }),
          catchError((error) => {
            let errorMessage = '';
            if (error instanceof HttpErrorResponse) {
              errorMessage = error.error.errorKey;
            } else {
              errorMessage = error;
            }
            return of(AddServicesToBillingaccountsWizardActions.createNewAddServicesToBillingaccountsFail({ errorMessage }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private addBillingitemsWizardService: AddBillingitemsWizardDataService
  ) {}
}
